module.exports = __webpack_public_path__ + "img/logo fiel.7843c427.png";